import script from "./ProgramOverviewFour.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramOverviewFour.vue?vue&type=script&setup=true&lang=js"

import "./ProgramOverviewFour.vue?vue&type=style&index=0&id=5a02753c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a02753c"]])

export default __exports__